import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "../hooks/useAuthCompat";
import { publicApi, useApi } from "../hooks/useApi";
import { useMuscleSchoolEnroll } from "../hooks/useMuscleSchoolEnroll";
import { TMSHero } from "../components/muscleschool/TMSHero";
import { TMSInstitution } from "../components/muscleschool/TMSInstitution";
import { TMSOutcomes } from "../components/muscleschool/TMSOutcomes";
import { TMSAudience } from "../components/muscleschool/TMSAudience";
import { TMSCurriculum } from "../components/muscleschool/TMSCurriculum";
import { TMSEnrollCTA } from "../components/muscleschool/TMSEnrollCTA";

export default function TheMuscleSchool() {
  const api = useApi();
  const { isSignedIn } = useUser();
  const curriculumRef = useRef(null);
  const { enroll, checkingOut, guestCheckoutEnabled } = useMuscleSchoolEnroll();

  const { data: curriculum, isLoading } = useQuery({
    queryKey: ["tms-curriculum", isSignedIn],
    queryFn: async () => (await api.get("/school/curriculum")).data,
  });
  const { data: offers } = useQuery({ queryKey: ["offers"], queryFn: async () => (await publicApi.get("/offers")).data });
  const price = offers?.find((o) => o.product_type === "muscle_school")?.price;
  const enrolled = !!curriculum?.enrolled;

  const scrollToCurriculum = () => curriculumRef.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="theme-school" data-testid="tms-landing-page">
      <TMSHero enrolled={enrolled} onEnroll={enroll} checkingOut={checkingOut} price={price} onScrollCurriculum={scrollToCurriculum} guestCheckoutEnabled={guestCheckoutEnabled} />
      <TMSInstitution />
      <TMSOutcomes />
      <TMSAudience />
      <div ref={curriculumRef}>
        <TMSCurriculum acts={curriculum?.acts} enrolled={enrolled} isLoading={isLoading} />
      </div>
      <TMSEnrollCTA enrolled={enrolled} onEnroll={enroll} checkingOut={checkingOut} price={price} />
    </div>
  );
}
